import { ReactNode } from 'react';
import _ from 'lodash';

import { ButtonVariant, ButtonTheme } from '../../ui/button/variants';
import WarningRed from '@/assets/icons/warning-red.svg';
import { Button, Modal } from '@/shared/ui';

interface IProps {
    open: boolean;
    title: ReactNode;
    onConfirm?(): void;
    onCancel?(): void;
    onClose?(): void;
    showEndIcon?: boolean;
    className?: string;
    cancelTheme?: ButtonTheme;
    cancelVariant?: ButtonVariant;
    confirmTheme?: ButtonTheme;
    confirmClassName?: string;
    confirmVariant?: ButtonVariant;
    confirmText?: ReactNode;
    cancelText?: ReactNode;
    children?: ReactNode;
    loading?: boolean;
    withIcon?: boolean;
    customIcon?: string;
    titleClassName?: string;
    iconClassName?: string;
    cancelClassName?: string;
    cancelButtonHidden?: boolean;
    closeIcon?: boolean;
    childrenContainerClassName?: string;
    cancelFontClassName?: string;
}

export const ConfirmModal = ({
    open,
    title,
    onConfirm,
    onCancel,
    onClose,
    cancelTheme,
    cancelVariant = 'outlined',
    cancelClassName = '',
    confirmTheme,
    confirmClassName = '',
    confirmVariant,
    showEndIcon = true,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    loading,
    children,
    withIcon = true,
    cancelButtonHidden = false,
    titleClassName = '',
    iconClassName = '',
    className = '',
    customIcon,
    closeIcon,
    childrenContainerClassName = '',
    cancelFontClassName = '',
}: IProps) => (
    <Modal dataTestId="confirm-modal" defaultPaddings={false} open={open} onClose={onClose || onCancel || _.noop} hideCloseIcon={!closeIcon} contentClassName={`${className} xl:max-w-[488px] p-5 sm:p-12`}>
        <div className="flex flex-col items-center justify-center" data-testid="confirm-modal-container">
            {withIcon && <img width={56} className={`${iconClassName} mb-1 sm-max:w-[48px]`} src={customIcon || WarningRed} alt="warning" />}
            <h3 className={`${titleClassName} mb-5 text-center font-agrandir text-[1.75rem] sm-max:text-[1.5625rem]`}>{title}</h3>
            {children && <div className={`mb-5 w-full max-w-[100%] ${childrenContainerClassName}`}>{children}</div>}

            <div className="flex w-full flex-col">
                <Button
                    testId="button-confirm-modal-confirm"
                    className={`confirm_modal__confirm ${confirmClassName}`}
                    type="submit"
                    sx={{ width: '100%', marginBottom: !cancelButtonHidden ? '1rem' : '0', fontSize: '1.125rem' }}
                    onClick={onConfirm}
                    showEndIcon={showEndIcon}
                    loading={loading}
                    disabled={loading}
                    {...(confirmTheme && { theme: confirmTheme })}
                    {...(confirmVariant && { variant: confirmVariant })}
                >
                    <span>{confirmText}</span>
                </Button>
                {!cancelButtonHidden && <Button
                    testId="button-confirm-modal-cancel"
                    className={`confirm_modal__cancel ${cancelClassName}`}
                    sx={{ width: '100%', fontSize: '1.125rem' }}
                    variant={cancelVariant}
                    {...(cancelTheme && { theme: cancelTheme })}
                    onClick={onCancel}
                    fontClassName={cancelFontClassName}

                >
                    <span>{cancelText}</span>
                </Button>}
            </div>
        </div>
    </Modal>
);
